<template>
  <div class="test-container">
    测试接口界面
      <div>
 <el-pagination
    
      :current-page="1"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="11"
      layout="total, prev, pager, next, jumper, ->, sizes"
      :total="5000"
    ></el-pagination>
  </div>
  </div>
</template>

<script>
import {setUserAccount,setPassWord,setPhone,addPublisher} from "@/api/manage"
import {getCode} from "@/api/user"
import {getSTStoken,postUpload} from "@/api/file"
export default {
    data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 5000
    };
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
    }
  }
,async created(){
    // console.log(localStorage.getItem('token').slice(6));
    
    // const res=await postUpload({ "bucket": "sxvault",
    // "object": "5/保险箱/我的文档/test0",
    // "size": 9,
    // "file": {
    //     "access_token": localStorage.getItem('token').slice(5),
    //     "file_hash": "test-file-hash"
    // }})
    // const res=await getSTStoken()
    // console.log(res);
    
    // const res= await setUserAccount({
    //      username: "Alex3",
    //   avatar_bucket:"sxdatasets",
    //   avatar_object:"1/avatar/songzu.jpeg"
    // })
    // const res=await setPassWord({
    // old_password: "123456",
    //   new_password: "654321"
    // })
    // this.getCodefn()
    // const res=await addPublisher({
    // publisher_name: "SJNX",
    // website:"http://sjnx.cn",
    // email:"sjnx@gmail.com",
    // telphone: "010-77778888",
    // introduction: "SJNX Corp"
    // })
    // console.log(res);
    
},
methods:{
   async getCodefn(){
const res1=await getCode({
      phone:"17628094266",
    reason:"sign-up",
    mock: false
})
 this.oldtoken=  res1.phone_token
 const res2=await getCode({
    phone:"17628094267",
    reason:"sign-up",
    mock: false
 })
 this.newtoken=res2.phone_token
const res3=await setPhone({
        old_phone: "17628094266",
        old_phone_token:this.oldtoken,
        old_phone_verification_code: "111111",
        new_phone: "17628094267",
        new_phone_token:this.newtoken,
        new_phone_verification_code: "111111"
})
console.log(res3);


   }

}
}
</script>

<style scoped>

</style>